import { render, staticRenderFns } from "./TableCalendar.vue?vue&type=template&id=3ecd7c0a&"
import script from "./TableCalendar.vue?vue&type=script&lang=ts&"
export * from "./TableCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports